import { Alert, AlertTitle } from "@mui/material";
import { FileWarning } from "lucide-react";

export default () => (
  <Alert
    severity="warning"
    icon={<FileWarning size={20} />}
    sx={{ borderRadius: "10px", alignItems: "center" }}
  >
    <AlertTitle>Document has been deleted</AlertTitle>
    This document is no longer available.
  </Alert>
);
